
import React from "react";
import { Tabs } from 'antd';
import { performanceApi } from "./AllTabContent";
const PerformanceTab = () => {
  return (
    <div className="tab-section-sec">
      <div className="container">
        <div className="tabs">
          <Tabs
            defaultActiveKey="1"
            items={performanceApi}
          />
        </div>
      </div>
    </div>
  )
}
export default PerformanceTab;